import { render, staticRenderFns } from "./addAmenity.vue?vue&type=template&id=592a79de"
import script from "./addAmenity.vue?vue&type=script&lang=js"
export * from "./addAmenity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports